import CategoryComponentChild from "./categoryComponent/CategoryComponentChild";

const Category = ({ data }) => {
  if (data && data.is_active)
    return (
      <div className="w-100 category-box d-none d-lg-block mb-30 mt-60 d-flex">
        <h2 className="products-title">
          <span> {data.title} </span>
        </h2>
        <div className="row">
          {data.items.map((item, index) => {
            return (
              <CategoryComponentChild key={(data.id + index) * 2} item={item} />
            );
          })}
        </div>
      </div>
    );
};

export default Category;
